import { createSlice } from '@reduxjs/toolkit'
import { USER_ACTION } from '../../utils/constants/UIConstants'

export const defaultUserRoleData = {
  userName: '',
  phone: '',
  email: '',
}

export const domainNameInitialData = {
  domainName: '',
  code: '',
  tenantName: '',
}

export const ApplicationTypes = {
  PrideOwnershipApp: '',
  CustomerApp: '',
  ControlPlaneApp: '',
}

const userRolesReducer = createSlice({
  name: 'userRole',
  initialState: {
    userType: '',
    userInfo: defaultUserRoleData,
    roles: [],
    haulerCode: '',
    customerCode: '',
    applicationTypes: ApplicationTypes,
    domainName: domainNameInitialData,
  },
  reducers: {
    addUserData: (state, action) => {
      const { type, data } = action.payload
      switch (type) {
        case USER_ACTION.ADD_USER_INFO: {
          return {
            ...state,
            userInfo: data,
          }
        }
        case USER_ACTION.ADD_USER_TYPE: {
          return {
            ...state,
            userType: data,
          }
        }
        case USER_ACTION.ADD_USER_ROLES: {
          return {
            ...state,
            roles: data,
          }
        }
        case USER_ACTION.ADD_HAULER_SELECTION: {
          return {
            ...state,
            haulerCode: data,
          }
        }
        case USER_ACTION.ADD_CUSTOMER_SELECTION: {
          return {
            ...state,
            customerCode: data,
          }
        }
        case USER_ACTION.REMOVE_USER_INFO: {
          return {
            ...state,
            userInfo: defaultUserRoleData,
          }
        }
        case USER_ACTION.REMOVE_USER_TYPE: {
          return {
            ...state,
            userType: null,
          }
        }
        case USER_ACTION.REMOVE_USER_ROLES: {
          return {
            ...state,
            roles: [],
          }
        }
        case USER_ACTION.REMOVE_HAULER_SELECTION: {
          return {
            ...state,
            haulerCode: '',
          }
        }
        case USER_ACTION.REMOVE_CUSTOMER_SELECTION: {
          return {
            ...state,
            customerCode: '',
          }
        }
        default:
          return state
      }
    },
    addApplicationTypes: (state, action) => {
      state.applicationTypes = action.payload
    },
    addDomainName: (state, action) => {
      state.domainName = action.payload
    },
  },
})

export const { addUserData, addApplicationTypes, addDomainName } =
  userRolesReducer.actions

export default userRolesReducer.reducer
